module.exports = __webpack_public_path__ + "media/images/home/icon-star-full-ffe742ade96676eda00f6d37a3db3848.svg";